const isSuperChargingStation = station => {
  return Number(station.ev_dc_fast_num) > 0;
};

export default isSuperChargingStation;
